import { render, staticRenderFns } from "./campaignSettings.vue?vue&type=template&id=4fb1b3a7"
import script from "./campaignSettings.vue?vue&type=script&lang=js"
export * from "./campaignSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports